import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileManagementComponent } from './file-management.component';
import { Layouts } from '../app.component'

const routes: Routes = [
  {
      path: 'files',
      component: FileManagementComponent,
      data: { layout: Layouts.Main }
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FilesRoutingModule { } 